var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "z-0" },
    [
      _c(
        "overlay",
        {
          attrs: {
            name: "signup",
            height: "auto",
            width: "90%",
            "max-width": 425,
            adaptive: true,
            scrollable: true,
            resizeable: true,
            reset: true
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "db absolute z-999 z-2 right-0 mt2 mh2 pointer grow menu-icon-close",
              attrs: { alt: "close modal" },
              on: {
                click: function($event) {
                  return _vm.$modal.hide("signup")
                }
              }
            },
            [
              _c("span"),
              _vm._v(" "),
              _c("span"),
              _vm._v(" "),
              _c("span"),
              _vm._v(" "),
              _c("span")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "db relative z-998 center mw8 w-100 vh-85-xs h-modal-ns pa3"
            },
            [
              _c("section", { staticClass: "db relative center w-100 h-100" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex relative center h-100 flex-column items-center content-center justify-center"
                  },
                  [
                    _c("signup"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex center flex-row items-center justify-between w-100 mw5 mw6-ns mt3 mw21rem"
                      },
                      [_c("social-icons")],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "db absolute bottom-0 w-100 nb2 nb3-ns w-105 mh--05"
            },
            [
              _c("simple-svg", {
                attrs: {
                  filepath:
                    "/assets/images/svg/gdz18-grandoozy-logo-outline.svg",
                  id: "gdz-logo-footer-green"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "overlay",
        {
          ref: "youtube",
          class: "overlay-video",
          attrs: {
            name: "video",
            ytId: _vm.ytId,
            iframeSrc: _vm.iframeSrc,
            height: "auto",
            width: "100%",
            "max-width": 992,
            adaptive: true,
            scrollable: true,
            resizeable: true,
            reset: true
          },
          on: { "before-open": _vm.beforeOpen }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "db relative z-998 center mw8 w-100 vh-85-xs vh-75-ns ph2",
              on: {
                click: function($event) {
                  return _vm.$modal.hide("video")
                }
              }
            },
            [
              _c(
                "section",
                { staticClass: "db relative z-998 center w-100 h-100" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex relative z-998 center h-100 flex-column items-center content-center justify-center"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "db relative z-998 center w-100 h-auto"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "db absolute z-999 z-2 right-0 top-0 nr1 nt4 nt3 pointer grow menu-icon-close",
                              attrs: { alt: "close modal" },
                              on: {
                                click: function($event) {
                                  return _vm.$modal.hide("video")
                                }
                              }
                            },
                            [
                              _c("span"),
                              _vm._v(" "),
                              _c("span"),
                              _vm._v(" "),
                              _c("span"),
                              _vm._v(" "),
                              _c("span")
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "video-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "absolute absolute--fill" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modal-vid-container modal-element video-wrapper"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modal-vid-embed-wrapper modal-element absolute--fill"
                                      },
                                      [
                                        _c("iframe", {
                                          staticStyle: {
                                            border: "solid 1px #F2FFE5"
                                          },
                                          attrs: {
                                            id: "existing-iframe-example",
                                            width: "640",
                                            height: "360",
                                            src:
                                              "https://www.youtube.com/embed/hwR_1EP18eo?enablejsapi=1&autoplay=1",
                                            frameborder: "0"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "db dn-ns absolute bottom-0 w-100 nb1 nb2-ns"
          })
        ]
      ),
      _vm._v(" "),
      _c("app-header", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isIntroPage == false,
            expression: "isIntroPage == false"
          }
        ]
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "appfade" } },
        [
          _c("router-view", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.appIsLoaded,
                expression: "appIsLoaded"
              }
            ]
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("app-footer", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isIntroPage == false,
            expression: "isIntroPage == false"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }